import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3820830c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-none p-2 m-0" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-book mr-2" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "OBJEDNÁVKY", -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "flex align-items-center p-3 border-round text-500 p-ripple" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-comments mr-2" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "KOMUNIKÁCIA", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "list-none p-1 ml-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-envelope mr-2" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "Neprečítané", -1))
const _hoisted_12 = {
  key: 0,
  class: "inline-flex align-items-center justify-content-center ml-auto bg-blue-400 text-0 border-circle",
  style: {"min-width":"1.5rem","height":"1.5rem"}
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-file-excel mr-2" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "Nezatriedené", -1))
const _hoisted_15 = {
  key: 0,
  class: "inline-flex align-items-center justify-content-center ml-auto bg-blue-400 text-0 border-circle",
  style: {"min-width":"1.5rem","height":"1.5rem"}
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "flex align-items-center p-3 border-round text-500 p-ripple" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-arrow-circle-down mr-2" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "DODÁVATELIA", -1))
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = { class: "list-none p-1 ml-4" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-warehouse mr-2" }, null, -1))
const _hoisted_23 = { class: "font-medium" }
const _hoisted_24 = {
  key: 0,
  class: "inline-flex align-items-center justify-content-center ml-auto bg-red-400 text-0 border-circle",
  style: {"min-width":"1.5rem","height":"1.5rem"}
}
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { class: "flex align-items-center p-3 border-round text-500 p-ripple" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-bookmark mr-2" }, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "ZNAČKY", -1))
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = { class: "list-none p-1 ml-4" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-bookmark mr-2" }, null, -1))
const _hoisted_32 = { class: "font-medium" }
const _hoisted_33 = {
  key: 0,
  class: "inline-flex align-items-center justify-content-center ml-auto bg-blue-400 text-0 border-circle",
  style: {"min-width":"1.5rem","height":"1.5rem"}
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-envelope mr-2" }, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "IGNOROVANÉ EMAILY", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", null, [
      _withDirectives((_openBlock(), _createBlock(_component_router_link, {
        to: "/mod-orders/orders",
        class: "no-underline flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple"
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _hoisted_3
        ]),
        _: 1
      })), [
        [_directive_ripple]
      ])
    ]),
    ($data.store.user.department.id != 1)
      ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8)), [
            [_directive_ripple]
          ]),
          _createElementVNode("ul", _hoisted_9, [
            _createElementVNode("li", null, [
              _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                to: "/mod-orders/messages/1/0",
                class: "no-underline flex align-items-center cursor-pointer pt-1 pl-2 pb-2 pr-2 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple"
              }, {
                default: _withCtx(() => [
                  _hoisted_10,
                  _hoisted_11,
                  ($data.unreadRecords)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString($data.unreadRecords), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })), [
                [_directive_ripple]
              ])
            ]),
            _createElementVNode("li", null, [
              _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                to: "/mod-orders/messages/2/0",
                class: "no-underline flex align-items-center cursor-pointer p-2 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple"
              }, {
                default: _withCtx(() => [
                  _hoisted_13,
                  _hoisted_14,
                  ($data.unassignedRecords)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString($data.unassignedRecords), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })), [
                [_directive_ripple]
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    ($data.store.user.department.id != 1)
      ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_20)), [
            [_directive_ripple]
          ]),
          _createElementVNode("ul", _hoisted_21, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.store.suppliers, (s) => {
              return (_openBlock(), _createElementBlock("li", {
                key: s.id
              }, [
                _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                  to: '/mod-orders/messages/3/'+s.id,
                  class: "no-underline flex align-items-center cursor-pointer p-2 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple"
                }, {
                  default: _withCtx(() => [
                    _hoisted_22,
                    _createElementVNode("span", _hoisted_23, _toDisplayString(s.company), 1),
                    ($data.supplierRecords.get(s.id))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString($data.supplierRecords.get(s.id)), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["to"])), [
                  [_directive_ripple]
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    ($data.store.user.department.id != 1)
      ? (_openBlock(), _createElementBlock("li", _hoisted_25, [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_29)), [
            [_directive_ripple]
          ]),
          _createElementVNode("ul", _hoisted_30, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.store.marks, (m) => {
              return (_openBlock(), _createElementBlock("li", {
                key: m.id
              }, [
                _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                  to: '/mod-orders/messages/4/'+m.id,
                  class: "no-underline flex align-items-center cursor-pointer pt-1 pl-2 pb-2 pr-2 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple"
                }, {
                  default: _withCtx(() => [
                    _hoisted_31,
                    _createElementVNode("span", _hoisted_32, _toDisplayString(m.name), 1),
                    ($data.markRecords.get(m.id))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString($data.markRecords.get(m.id)), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["to"])), [
                  [_directive_ripple]
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("li", null, [
      ($data.store.token != '' && $data.store.user.admin === true)
        ? _withDirectives((_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: "/mod-orders/ignored_emails",
            class: "no-underline flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple"
          }, {
            default: _withCtx(() => [
              _hoisted_34,
              _hoisted_35
            ]),
            _: 1
          })), [
            [_directive_ripple]
          ])
        : _createCommentVNode("", true)
    ])
  ]))
}